import type { SearchResult } from '@core/Areas/Search/types'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'
import { get } from '@core/Services/ApiService'

export const getRacingSearchResults = (searchTerm: string) => {
  trackEvent(keys.searchQuery, { searchQueryText: searchTerm })
  return get<{ results: SearchResult[] }>({
    url: `/api/search/query?q=${searchTerm}&includeUnmatched`,
  })
}
